import {
  Upload,
  Row,
  Col,
  Image,
  Button,
  Modal,
} from "antd";
import TableAl from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveProductReducer,
  deleteProductReducer,
  getProductById,
} from "../../store/productReducer";

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import ProductSearch from '../../components/base/productSearch'
// import { io } from 'socket.io-client';
import { imageUrl, viewImageUrl } from "../../utils/staticValues";
// const socket = io('ws://localhost:4000');
const ViewProduct = () => {
  const navigate = useHistory();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const { crdentialDataForOne } = useSelector((state) => state.login);
  // const [statuss, setStatus] = useState("");
  const [actionss, setActionss] = useState("");
  const [productId, setProductId] = useState("");
  const { products,isLoading:isLoadingProduct } = useSelector((state) => state.product);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ setFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [cacheBuster, setCacheBuster] = useState(Date.now());
  const handleChange = (info) => {
    if (info.file.status === "done") {
      toast.success(`${info.file.name} file uploaded successfully`);
      setCacheBuster(Date.now());
      setFile(info.file); // Update the file state
    } else if (info.file.status === "error") {
      toast.error(`${info.file.name} file upload failed.`);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      toast.info("You can only upload JPG/PNG files!");
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.info("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

 

  const customRequest = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("product_image", file); // Append the file to form data

    try {
      await axios.post(
        imageUrl + productId,
        formData,
        {
          headers: {
            "Content-Type": "maultipart/form-data",
            "authorization": `${localStorage.getItem("token")}`
          },
        }
      );
      onSuccess(
        dispatch(getActiveProductReducer())
      ); // Call onSuccess with the response
    } catch (error) {// Call onError in case of failure
    }
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const dispatch = useDispatch();

  useEffect(()=>{
    // socket.on('connect', () => {
    //   console.log("here")
    //   console.log('Connected to the socket server');
    // });
    // socket.on('products_updated', (data) => {
    //   console.log(data)
    //   console.log('Connected to the products_updated');
    // });
    // socket.on('incoming_list_submitted', (data) => {
    //   // console.log(data)
    //   console.log('Connected to the socket server');
    // });
  })

  useEffect(() => {
    dispatch(getActiveProductReducer({ page: currentPage, limit: pageSize }));
    setActionss(true);
  }, [dispatch, currentPage, pageSize]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size); // Update page size
    setCurrentPage(1); // Reset to first page when page size changes
  };

  const handlePreview = (imageUrl) => {
    setPreviewImage(imageUrl);
    setPreviewOpen(true);
  };
  const addNewImage = (id) => {
    setProductId(id);
    setIsModalOpen(true);
  };

  const handleDelete = (productData) => {
    Modal.confirm({
      centered: true,
      okCancel: "Cancel",
      okText: "Delete",
      onOk: () => dispatch(deleteProductReducer({ id: productData._id })),
      title: "Confirmation",
      content: "Are you sure to delete this product",
    });
  };

  

  


  const editProduct = (productDataOnclick) => {
    navigate.push("/addproduct/" + productDataOnclick._id);
    dispatch(getProductById(productDataOnclick));
  };
  const Image_url = viewImageUrl;

  const colummm = [
    {
      title: "Product Name",
      width: "35%",
      key: "name",
      render: (text, record) => (
        <span style={{ display: "flex", flexDirection: "column", gap: "4" }}>
          <h5>{record.name}</h5>
          <p>
            <span style={{ fontWeight: "bold" }}></span>
            {record.code}
          </p>
          <p>{record.description}</p>
        </span>
      ),
    },
    {
      title: "Product Image",
      render: (text, record) => (
        <span>
          {record.image_extension ? (
            <>
              <Image
                width={100}
                src={Image_url + record._id + record.image_extension + `?${cacheBuster}`}
                onClick={() =>
                  handlePreview(Image_url + record._id + record.image_extension)
                }
                style={{ cursor: "pointer" }}
                preview={{
                  visible: previewOpen,
                  src: previewImage,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                }}
              />
              {crdentialDataForOne?.role === "warehouseAdmin" && <Button
                icon={<EditOutlined />}
                onClick={() => addNewImage(record._id)}
                style={{ marginLeft: 8 }}
              />}
            </>
          ) : (
            crdentialDataForOne?.role === "warehouseAdmin" ? <Button onClick={() => addNewImage(record._id)}>Add Image</Button> : "N/A"
          )}
        </span>
      ),
    },
    {
      title: "Product Category",
      render: (text, record) => <span>{record.category?.name}</span>,
    },

    {
      title: "specifications",
      render: (text, record) => (
        <ul>
          {record?.specifications?.map((item, index) => (
            <li key={index}>
              <b>{item.name}</b>: {item.value}
            </li>
          ))}
        </ul>
      ),
    },
    {
      title: "Quantity Measurements",
      render: (text, record) => (
        <ul>
          {record?.quantity?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ),
    },
  ];
  if (crdentialDataForOne.role === "warehouseAdmin") {
    colummm.push({
      title: "Actions",
      render: (text, record) => (
        <span>
          {actionss && (
            <Button
              onClick={() => editProduct(record)}
              style={{ marginRight: 8 }}
              icon={<EditOutlined />}
            ></Button>
          )}
          {actionss && (
            <Button
              onClick={() => handleDelete(record)}
              icon={<DeleteOutlined />}
            ></Button>
          )}
          {/* {statuss && (
            <Button
              onClick={() => handleActivate(record)}
              icon={<UndoOutlined />}
            ></Button>
          )} */}
        </span>
      ),
    });
  }
  return (
    <div>
      <h2 className="text-xl mb-2">List of Products</h2>
      <Modal
        title="Add image product"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Upload
          customRequest={customRequest}
          showUploadList={false} // Hide the upload list
          beforeUpload={beforeUpload}
          onChange={handleChange}
          accept=".jpg,.jpeg,.png" // Accept only JPG and PNG files
        >
          <Button icon={<UploadOutlined />}>Upload Image</Button>
        </Upload>
      </Modal>
      <Row gutter={20}>
        
        
        
        <Col xs={24} sm={24} lg={8}>
          <ProductSearch />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          {crdentialDataForOne?.role === "warehouseAdmin" && (
            <Button
              style={{ backgroundColor: "#5856d6", color: "white" }}
              onClick={() => navigate.push("/addproduct")}
              className="bg-blue-300"
            >
              Add new product
            </Button>
          )}
        </Col>
      </Row>

      <div>
        <TableAl
          columnnn={colummm}
          isLoadinggg={isLoadingProduct}
          dataaa={products?.data?.products}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: products?.data?.total_count,
            onChange: handlePageChange,
          }}
          onPageSizeChange={handlePageSizeChange} // Pass the page size change handler
        />
      </div>
    </div>
  );
};
export default ViewProduct;
